import React from 'react';

export const CustomIcon = props => {
  const {name} = props;

  if (name) {
    return <i className={`icon ${name}`}/>
  }

  return null;
};

export default CustomIcon;
